{
  "currentIteration": 4,
  "buildVersion": "1.0.1.261030-62338"
}